import API from "./API";

export default class ColorDAO {
    static getColorByItemId = async (id) => {
        return await API.request(`/v1/item_color/item/${id}`, "GET");
    }


}